
import Block from 'Mixins/Block';
import { publish, subscribe } from 'Mixins/pubsub';

export default Block('component-header-toggle', {
	onLoad (qComponent) {

		qComponent.addEvent('click', () => {

			publish('component-header-toggle');

		});

		subscribe('component-header-change', isOpen => {

			if (isOpen) {
				document.querySelector('body').classList.add('menu-open');
				qComponent.addClass('component-header-toggle--is-active');
				qComponent.setAttr('aria-expanded', true);

			} else {
				document.querySelector('body').classList.remove('menu-open');
				qComponent.removeClass('component-header-toggle--is-active');
				qComponent.removeAttr('aria-expanded', false);

			}

		});

	}
});
